<template>
    <v-container fluid>
        <div>
            <v-row>
                <v-col class="pl-5">
                    <v-btn v-if="inEditMode" class="ml-2 mr-2" color="primary" @click="lockClick(null)">
                        <v-icon small>fa-lock</v-icon>&nbsp;{{ $t('buttons.lock') }}
                    </v-btn>
                    <v-btn v-if="!inEditMode" class="ml-2 mr-2" color="primary" @click="editClick()">
                        <v-icon small>fa-edit</v-icon>&nbsp;{{ $t('buttons.edit') }}
                    </v-btn>
                </v-col>
            </v-row>
            <v-row> </v-row>
        </div>
        <v-row>
            <v-col cols="12">
                <div v-for="value in salaries" :key="value.id">
                    <PlacementSalaryTable :inEditMode="inEditMode" :reload="reloadData" :salary="value" />
                </div>
            </v-col>
        </v-row>
    </v-container>
</template>

<script>
import PlacementSalaryTable from './PlacementSalaryTable.vue';

export default {
    name: 'PlacementSalary',
    components: {PlacementSalaryTable},
    data: function () {
        return {
            initialLoad: false,
            lockKey: 'placement-salary',
            lockTimer: null,
            salaries: [],
        };
    },
    props: ['placement', 'inEditMode'],
    methods: {
        reloadData() {
            let vm = this;
            this.$APICall('get', 'salaries/' + this.placement.id, {}, (data, success) => {
                if (success) {
                    let usableData = JSON.parse(JSON.stringify(data.items));
                    vm.salaries = usableData;
                }
            });
        },
        lockClick() {
            this.$emit('edit');
        },
        editClick() {
            this.$emit('edit');
        },
        backClick() {
            this.$router.go(-1);
        },
    },
    beforeRouteLeave(to, from, next) {
        if (this.inEditMode) {
            let vm = this;
            this.$verify(this.$t('alerts.leaveQuestion'), (result) => {
                if (result) {
                    if (vm.lockTimer !== null) clearInterval(this.lockTimer);
                    vm.removeLock();
                    next(true);
                } else {
                    next(false);
                }
            });
        } else {
            next(true);
        }
    },
    mounted() {
        if (!this.$myStore.state.loggedIn) {
            this.$router.replace('login');
        } else {
            this.reloadData();
        }
    },
};
</script>

<style scoped></style>
